export const VALID_IMAGE_TYPES = [
  'BITEWING',
  'PERIAPICAL',
  'PANORAMIC',
] as const;
export type TValidImageType = (typeof VALID_IMAGE_TYPES)[number];

export const IMAGE_TYPE_ABBREVIATIONS: Record<string, string> = {
  BITEWING: 'BW',
  PERIAPICAL: 'PA',
  PANORAMIC: 'PAN',
  FMX: 'FMX',
};

export type VisitAttachmentsTabProps = {
  patientId: string;
  videaId?: string; // Optional videaId for direct lookup
  onImagesChange?: (
    images: Array<{ path: string; analysisId: string }>,
  ) => void;
  isOralinxV2?: boolean; // When true, visit selection is optional
};

export interface SelectedVisit {
  id: number;
  date: string;
}

export interface Visit {
  id: number | null;
  patientVideaId: string | null;
  firstImageCreatedAt: Date | null;
  imageCount: number | null;
  visitDate: Date | null;
  source: 'STANDALONE' | 'DDAI';
  imageTypeCounts: {
    type: 'BITEWING' | 'PERIAPICAL' | 'PANORAMIC' | 'OTHER' | 'COLOR_IMAGE';
    count: string | number | bigint;
  }[];
}

export interface VisitImage {
  visitId: number;
  path: string;
  imageType: TValidImageType;
  analysisId: string;
}

export interface VisitDropdownItemProps {
  visit: Visit;
  isSelected: boolean;
  isLatestVisit: boolean;
  onToggleSelection: (visit: Visit) => void;
}

export interface VisitTagProps {
  visit: SelectedVisit;
  originalVisit?: Visit;
  onRemove: (visit: Visit) => void;
}

export type VisitWithId = Visit & {
  id: number;
};
